import BpmnSnapping from './BpmnSnapping';

export default {
  __init__: [ 'snapping' ],
  snapping: [ 'type', BpmnSnapping ]
};